import type { JSX } from "react";
import React from "react";
import Logo from "@/assets/QubeeLogo.png";
import { Timeline } from "primereact/timeline";

interface QubeeCore {
    title: string;
    description: string;
};

function QubeeCoreCard(core: QubeeCore): JSX.Element {
    return (
        <div className="card flex flex-col gap-5 p-4">
            <div className="text-lg md:text-xl font-bold text-yellow-400">
                { core.title }
            </div>

            <div className="text-sm md:text-md text-gray-600">
                { core.description }
            </div>
        </div>
    )
}

export function AboutUs(): JSX.Element {
    const [width, setWidth] = React.useState(window.innerWidth);

    const cores: QubeeCore[] = [
        {
            title: "Clarity",
            description: "No generic, no confusion. All our modules are available with documentation and consistent quality.",
        },
        {
            title: "Compatibility",
            description: "Everything we offer is chosen with the tinkerer in mind — tested with Arduino, ESP32, Raspberry Pi, and more.",
        },
        {
            title: "Resources",
            description: "Our website hosts detailed product manuals, example projects, and wiring guides for beginners and pros alike.",
        },
        {
            title: "Vision",
            description: "We’re just getting started — our upcoming range includes exclusive in-house boards, curated project kits, and more."
        }
    ];

    React.useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    return (
        <div className="h-fit w-full flex flex-col p-8">
            <div className="h-10 md:h-16"></div>
            <div className="card flex flex-col items-center">
                <div className="row-span-1 text-4xl sm:text-6xl text-center font-bold p-10 text-gray-600">
                    About Us
                </div> 

                <div className="w-full h-full grid grid-flow-row justify-center items-center gap-10">
                    <div className="w-full flex flex-col lg:flex-row justify-center items-center gap-6">
                        <img className="w-sm" src={Logo} />

                        <div className="w-full flex flex-col text-center lg:text-left p-4 gap-5 lg:gap-1">
                            <div className="text-2xl font-bold text-gray-600">
                                Premium Electronics for Makers & Hobbyists
                            </div>
                            <div className="text-lg text-wrap">
                                Discover high-quality sensor modules, power boards, and DIY components — all under one trusted brand.
                            </div>
                        </div>
                    </div>

                    <div className="row-span-1 w-full px-4 pb-8">
                        <Timeline value={cores} align={ width > 690 ? "alternate" : "left" } content={QubeeCoreCard} />
                    </div>
                </div>
            </div>
        </div>
    )
}